import angular from 'angular';

angular.module('commonServices').filter('postAddress', [
  '$sce',
  '$translate',
  function($sce, $translate) {
    return function(address, separator, hideCountry) {
      if (!address) return null;
      if (typeof separator === 'undefined') separator = $sce.trustAs($sce.HTML, '<br/>');

      var country = '';

      // ReSharper disable once CoercedEqualsUsing
      if (hideCountry != 'true' && !!address.country) {
        var key = 'country_' + address.country;
        var translation = $translate.instant(key);
        country = translation === key ? address.country : translation;
      }

      return (
        address.street1 +
        ' ' +
        (address.number ? address.number : '') +
        (address.box ? '/' + address.box + ' ' : '') +
        separator +
        (address.street2 ? address.street2 + separator : '') +
        (address.zipCode ? address.zipCode + ' ' : '') +
        (address.city ? address.city + ' ' : '') +
        (country ? separator + country : '')
      );
    };
  },
]);
